import { version } from '../package.json';

export const DOTENV = import.meta.env.VITE_DOTENV || 'development';
// export const TITLE = import.meta.env.VITE_TITLE;
// export const SITE_URL = import.meta.env.VITE_SITE_URL;
// export const CONTACT_EMAIL = import.meta.env.VITE_CONTACT_EMAIL;

export const MM_WS_URL = import.meta.env.VITE_MM_WS_URL || 'ws://localhost';
export const MM_WS_SS_KEY = import.meta.env.VITE_MM_WS_SS_KEY || 'WS_URL_OVERRIDE';
export const MM_WS_QS_KEY = import.meta.env.VITE_MM_WS_QS_KEY || 'ws';

export const ES_WS_URL = import.meta.env.VITE_ES_WS_URL || 'ws://localhost';
export const ES_WS_SS_KEY = import.meta.env.VITE_ES_WS_SS_KEY || '';
export const ES_WS_QS_KEY = import.meta.env.VITE_ES_WS_QS_KEY || '';

export const ASSISTANT_WS_URL =
  import.meta.env.VITE_ASSISTANT_WS_URL || 'ws://localhost:3001/api/ws';
export const ASSISTANT_WS_SS_KEY = import.meta.env.VITE_ASSISTANT_WS_SS_KEY || '';
export const ASSISTANT_WS_QS_KEY = import.meta.env.VITE_ASSISTANT_WS_QS_KEY || '';

/**
 * WebSocket of the Assistant SMM API (`Invalidate` frames for social posts).
 * Local Caddy doesn't proxy it, so locally it points at assistant-smm directly.
 */
export const ASSISTANT_SMM_WS_URL =
  import.meta.env.VITE_ASSISTANT_SMM_WS_URL || 'ws://localhost:3008/api/ws';
export const ASSISTANT_SMM_WS_SS_KEY = import.meta.env.VITE_ASSISTANT_SMM_WS_SS_KEY || '';
export const ASSISTANT_SMM_WS_QS_KEY = import.meta.env.VITE_ASSISTANT_SMM_WS_QS_KEY || '';

export const AUTH_WS_URL = import.meta.env.VITE_AUTH_WS_URL || 'ws://localhost:3000/api/ws';
export const AUTH_WS_SS_KEY = import.meta.env.VITE_AUTH_WS_SS_KEY || '';
export const AUTH_WS_QS_KEY = import.meta.env.VITE_AUTH_WS_QS_KEY || '';

export const ALLOW_WS_OVERRIDE = import.meta.env.VITE_ALLOW_WS_OVERRIDE;
export const LISTEN_INTERVAL = +(import.meta.env.VITE_LISTEN_INTERVAL || 60000); // ms
export const LONG_POLING_INTERVAL = +(import.meta.env.VITE_LONG_POLING_INTERVAL || 60000); // ms
export const SMALL_TOKEN_THRESHOLD = import.meta.env.VITE_SMALL_TOKEN_THRESHOLD;

export const AUTH_BASE_URL = import.meta.env.VITE_AUTH_API_URL || 'http://localhost:3000';
export const ASSISTANT_API_URL = import.meta.env.VITE_ASSISTANT_API_URL || 'http://localhost:3000';
/**
 * Base URL of the Assistant SMM (social media management) API.
 * Like the other API URLs it defaults to a localhost port (assistant-smm's own), so a missing
 * deploy value fails loudly instead of silently routing social-* calls to the Assistant API.
 */
export const ASSISTANT_SMM_API_URL =
  import.meta.env.VITE_ASSISTANT_SMM_API_URL || 'http://localhost:3008';
export const CERBOS_API_URL = import.meta.env.VITE_CERBOS_API_URL || 'http://localhost:3592';
export const DEX_API_URL = import.meta.env.VITE_DEX_API_URL
  ? import.meta.env.VITE_DEX_API_URL
  : 'http://localhost';
export const DEX_API_LOAN_URL = import.meta.env.VITE_DEX_API_URL
  ? `${import.meta.env.VITE_DEX_API_URL}/loan`
  : 'http://localhost';
export const DEX_API_WEB_URL = import.meta.env.VITE_DEX_API_URL
  ? `${import.meta.env.VITE_DEX_API_URL}/web`
  : 'http://localhost';

export const ADMIN_URL = import.meta.env.VITE_ADMIN_URL || 'http://localhost';
export const ADMIN_X_TOKEN = import.meta.env.VITE_ADMIN_X_TOKEN || '';

export const SENTRY_PROJECT = import.meta.env.VITE_SENTRY_PROJECT;
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
export const SENTRY_TRACES_SAMPLE_RATE = import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || 1.0;

// other constants
export const PACKAGE_VERSION = import.meta.env.VITE_VERSION || version;
export const IS_AUTHZ_NAVIGATION_ENABLED = true;
export const EMPTY_ARRAY = [];
export const LIQUIDITY_STALENESS_THRESHOLD_MINUTES =
  import.meta.env.VITE_LIQUIDITY_STALENESS_THRESHOLD_MINUTES || 15;

export const TASK_CANCELLED_THRESHOLD_MINUTES =
  import.meta.env.VITE_TASK_CANCELLED_THRESHOLD_MINUTES || 5;
export const TASK_COMPLETED_THRESHOLD_MINUTES =
  import.meta.env.VITE_TASK_COMPLETED_THRESHOLD_MINUTES || 60;
